import { SVG, SVGProps } from './svg'

export function IconDrag(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M9 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm8-10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-2 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" />
    </SVG>
  )
}
